
import React, { Component } from 'react';
import { connect } from 'react-redux';
import actions from '../actions';
import ParkingPage from './../components/ParkingPage';
import { I18n } from 'react-redux-i18n';
import sharedActions from '../../../baseApp/shared/actions';

class ParkingPageContainer extends Component {

    componentDidMount() {
        const { 
            fetchSearchFieldsData,
            fetchParkingData,
            fetchTableData,
            fetchGraphData,
            parkingId
        } = this.props;        
       
        fetchSearchFieldsData(parkingId);

        fetchParkingData(parkingId);
        fetchTableData(parkingId);
        fetchGraphData(parkingId);
    }

    componentWillUnmount() {
        const { resetSelectedParking } = this.props;
        resetSelectedParking();
        this.props.updateCustomTitle();
        this.props.updateCustomBreadcrumbs();   
        
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.searchFieldsData.floorData.length !== 0){
            this.handleParkingLoadingCompleted(nextProps.parkingId, nextProps.searchFieldsData.floorData)
        }
    }

    handleParkingLoadingCompleted = (parkingId, floors) => {
        const { 
            updateCustomTitle,
            updateCustomBreadcrumbs
        } = this.props;

            updateCustomTitle(floors[0]?.parent.name);
            updateCustomBreadcrumbs([{
                link: "/parking",
                name: I18n.t('routes.parking')
            }, {
                link: "/parking/" + parkingId,
                name: floors[0]?.parent.name
            }]);
    };

    handleSearchFieldValueChanged = (searchComponent, fieldId, value) => {
        const { 
            handleTableSearchFieldValueChanged, 
            handleGraphSearchFieldValueChanged 
        } = this.props;

        if(searchComponent === 'table') {
            handleTableSearchFieldValueChanged(fieldId, value);
        } else if(searchComponent === 'graph') {
            handleGraphSearchFieldValueChanged(fieldId, value);
        }
    }

    handleCleanAllClicked = searchComponent => {
        const { 
            handleTableSearchFieldCleanAll, 
            handleGraphSearchFieldCleanAll 
        } = this.props;
        
        if(searchComponent === 'table') {
            handleTableSearchFieldCleanAll();
        } else if(searchComponent === 'graph') {
            handleGraphSearchFieldCleanAll();
        }
    }
    
    handleParkingTableSlotClicked = parkingSlot => {
        const { 
            openConfigurationModal
        } = this.props;

        openConfigurationModal(parkingSlot.id);
    }

    handleModalClose = () => {
        const { 
            closeConfigurationModal
        } = this.props;

        closeConfigurationModal();
    }

    handleSlotCategoryChanged = category => {
        const {
            changeSelectedCategory
        } = this.props;

        changeSelectedCategory(category);
    }

    handleChangeCategorySubmit = () => {
        const {
            submitNewCategory,
            changeCategoryModal: {
                selectedSlot: {
                    id: slotId,
                    selectedCategory,
                    name: selectedSlotName,
                    slotsData
                }
            }
        } = this.props;

        submitNewCategory(slotId, selectedCategory, selectedSlotName, slotsData);
    }

    handleFetchData = (searchComponent, searchFields) => {
        const { 
            parkingId, 
            fetchTableData,
            fetchGraphData
        } = this.props;

        if(searchComponent === 'table') {
            fetchTableData(parkingId, searchFields);
        } else if(searchComponent === 'graph') {
            fetchGraphData(parkingId, searchFields);
        }
    }

    onCollapseCategoryDataClicked = () => {
        const {
            collapseCategorySlotsData
        } = this.props;

        collapseCategorySlotsData();
    }

    render() {
        const { slotsData, table, graph, searchFieldsData, changeCategoryModal } = this.props;
        return (
            <ParkingPage
                slotsData={slotsData}
                table={table}
                graph={graph}
                changeCategoryModal={changeCategoryModal}

                searchFieldsData={searchFieldsData}
                handleFetchData={this.handleFetchData}
                handleCleanAllClicked={this.handleCleanAllClicked}
                handleSearchFieldValueChanged={this.handleSearchFieldValueChanged}

                onCollapseCategoryDataClicked={this.onCollapseCategoryDataClicked}

                handleParkingTableSlotClicked={this.handleParkingTableSlotClicked}
                handleModalClose={this.handleModalClose}

                handleSlotCategoryChanged={this.handleSlotCategoryChanged}
                handleChangeCategorySubmit={this.handleChangeCategorySubmit}
            />
        );
    }
}

const mapStateToProps = ({ parkingReducer }) => {
    return {
        searchFieldsData: parkingReducer.searchFieldsData,
        slotsData: parkingReducer.selectedParking.slotsData,
        table: parkingReducer.selectedParking.table,
        graph: parkingReducer.selectedParking.graph,
        changeCategoryModal: parkingReducer.selectedParking.changeCategoryModal
    };
};

const mapDispatchToProps = {
    ...actions,
    updateCustomTitle: sharedActions.updateCustomTitle,
    updateCustomBreadcrumbs: sharedActions.updateCustomBreadcrumbs,
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ParkingPageContainer);